/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetEventSlot,
  FleetEventSlotCreateInput,
  FleetEventSlotUpdateInput,
  SchemaValidationErrorResponse,
  SortFleetEventSlotsBody,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create event slot
 */
export const createFleetEventSlot = (
    fleetEventSlotCreateInput: MaybeRefOrGetter<FleetEventSlotCreateInput>,
 signal?: AbortSignal
) => {
      fleetEventSlotCreateInput = toValue(fleetEventSlotCreateInput);

      return axiosClient<FleetEventSlot>(
      {url: `/fleet-event-slots`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSlotCreateInput, signal
    },
      );
    }




export const getCreateFleetEventSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventSlot>>, TError,{data: FleetEventSlotCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetEventSlot>>, TError,{data: FleetEventSlotCreateInput}, TContext> => {

const mutationKey = ['createFleetEventSlot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetEventSlot>>, {data: FleetEventSlotCreateInput}> = (props) => {
          const {data} = props ?? {};

          return  createFleetEventSlot(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetEventSlotMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetEventSlot>>>
    export type CreateFleetEventSlotMutationBody = FleetEventSlotCreateInput
    export type CreateFleetEventSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create event slot
 */
export const useCreateFleetEventSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventSlot>>, TError,{data: FleetEventSlotCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetEventSlot>>,
        TError,
        {data: FleetEventSlotCreateInput},
        TContext
      > => {
      return useMutation(getCreateFleetEventSlotMutationOptions(options), queryClient);
    }
    /**
 * @summary Sort event slots
 */
export const sortFleetEventSlots = (
    sortFleetEventSlotsBody: MaybeRefOrGetter<SortFleetEventSlotsBody>,
 signal?: AbortSignal
) => {
      sortFleetEventSlotsBody = toValue(sortFleetEventSlotsBody);

      return axiosClient<void>(
      {url: `/fleet-event-slots/sort`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: sortFleetEventSlotsBody, signal
    },
      );
    }




export const getSortFleetEventSlotsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventSlots>>, TError,{data: SortFleetEventSlotsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventSlots>>, TError,{data: SortFleetEventSlotsBody}, TContext> => {

const mutationKey = ['sortFleetEventSlots'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sortFleetEventSlots>>, {data: SortFleetEventSlotsBody}> = (props) => {
          const {data} = props ?? {};

          return  sortFleetEventSlots(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SortFleetEventSlotsMutationResult = NonNullable<Awaited<ReturnType<typeof sortFleetEventSlots>>>
    export type SortFleetEventSlotsMutationBody = SortFleetEventSlotsBody
    export type SortFleetEventSlotsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Sort event slots
 */
export const useSortFleetEventSlots = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventSlots>>, TError,{data: SortFleetEventSlotsBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sortFleetEventSlots>>,
        TError,
        {data: SortFleetEventSlotsBody},
        TContext
      > => {
      return useMutation(getSortFleetEventSlotsMutationOptions(options), queryClient);
    }
    /**
 * @summary Update event slot
 */
export const updateFleetEventSlot = (
    id: MaybeRefOrGetter<string>,
    fleetEventSlotUpdateInput: MaybeRefOrGetter<FleetEventSlotUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetEventSlotUpdateInput = toValue(fleetEventSlotUpdateInput);

      return axiosClient<FleetEventSlot>(
      {url: `/fleet-event-slots/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSlotUpdateInput, signal
    },
      );
    }




export const getUpdateFleetEventSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSlot>>, TError,{id: string;data: FleetEventSlotUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSlot>>, TError,{id: string;data: FleetEventSlotUpdateInput}, TContext> => {

const mutationKey = ['updateFleetEventSlot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetEventSlot>>, {id: string;data: FleetEventSlotUpdateInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFleetEventSlot(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetEventSlotMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetEventSlot>>>
    export type UpdateFleetEventSlotMutationBody = FleetEventSlotUpdateInput
    export type UpdateFleetEventSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update event slot
 */
export const useUpdateFleetEventSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSlot>>, TError,{id: string;data: FleetEventSlotUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetEventSlot>>,
        TError,
        {id: string;data: FleetEventSlotUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateFleetEventSlotMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy event slot
 */
export const destroyFleetEventSlot = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/fleet-event-slots/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetEventSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSlot>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSlot>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyFleetEventSlot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetEventSlot>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyFleetEventSlot(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetEventSlotMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetEventSlot>>>

    export type DestroyFleetEventSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy event slot
 */
export const useDestroyFleetEventSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSlot>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetEventSlot>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyFleetEventSlotMutationOptions(options), queryClient);
    }
